import { render, staticRenderFns } from "./Interactions.vue?vue&type=template&id=2b4264ad"
import script from "./Interactions.vue?vue&type=script&lang=ts"
export * from "./Interactions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports